module.exports = __webpack_public_path__ + "img/cp-mp-r3-1.54f66952.jpg";